import { render, staticRenderFns } from "./GalleryDetailDefaultLayout.vue?vue&type=template&id=289444fe&scoped=true"
import script from "./GalleryDetailDefaultLayout.vue?vue&type=script&lang=js"
export * from "./GalleryDetailDefaultLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289444fe",
  null
  
)

export default component.exports